module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Header'), _vm._v(" "), _c('CRow', {
    attrs: {
      "title": 'Creators Get Paid By',
      "title2": 'You Play.',
      "ctaText": 'Choose a plan',
      "ctaAction": '#plans',
      "imgSrc": _vm.img,
      "order1": 2,
      "order2": 1,
      "fullWidth": true
    }
  }), _vm._v(" "), _c('CRow', {
    attrs: {
      "title": 'Track creators you support',
      "title2": 'on your dashboard',
      "imgSrc": _vm.img1,
      "order1": 1,
      "order2": 2
    }
  }), _vm._v(" "), _c('CRow', {
    attrs: {
      "title": ' Make money',
      "title2": 'sharing content',
      "imgSrc": _vm.img2,
      "order1": 2,
      "order2": 1
    }
  }), _vm._v(" "), _c('plans'), _vm._v(" "), _c('Footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-81bb547a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/landingPages/landing3.vue
// module id = 1800
// module chunks = 180